module.exports = __webpack_public_path__ + "img/travel-type.224141be.svg";